export const queryKeys = {
  chatbot: (chatbotId: string) => ["chatbots", chatbotId] as const,
  genesysIntegration: (chatbotId: string) => ["chatbots", chatbotId, "integrations", "genesys"] as const,
  domainFiles: (chatbotId: string, domainId: string | null) => ["chatbots", chatbotId, "files", domainId ?? "global"] as const,
  textSearches: (chatbotId: string, domainId?: string) => ["chatbots", chatbotId, "text-searches", domainId ?? "global"] as const,
  analytics: (chatbotId: string, from?: string, to?: string) => ["chatbots", chatbotId, "analytics", from ?? "", to ?? ""] as const,
  conversations: (chatbotId: string, params?: string) => ["chatbots", chatbotId, "conversations", params ?? ""] as const,
}
